import { actionHelper } from './actionHelper';
import { ACCOUNT_LOGIN, ACCOUNT_LOGOUT } from '../types/accountTypes';

export const accountLoginAction = (user) =>
  actionHelper(async () => {
    let payload;

    localStorage.setItem('token', JSON.stringify(user.accessToken));
    payload = { ...user, roles: [{ name: 'USER' }] };
    return {
      type: ACCOUNT_LOGIN,
      payload: payload,
    };
  });

export const accountLogoutAction = () => async (dispatch) => {
  localStorage.removeItem('token');
  dispatch({
    type: ACCOUNT_LOGOUT,
  });
};
